<script>
	import { createEventDispatcher, getContext, onMount } from 'svelte';

	import { keyToken } from './globals.js';
	import { formatCurrency } from './components/formatting.js';
	import SortableTable from './components/table/SortableTable.svelte';
	import StockTableCell from './components/table/StockTableCell.svelte';

	const dispatch = createEventDispatcher();

	const { getToken } = getContext(keyToken);
	const token = getToken();

	export let updates;

	let invalid;
	let stocks = [];
	let stock = null;

	$: {
		if (updates != null && (updates.type === 'alarms' || updates.type === 'prices')) {
			console.log('Received alarms update:', updates);
			loadAlarms();
		}
	}

	async function loadAlarms() {
		if (!token) {
			invalid = true;
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_alarms.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			}
		}).then(result => {
			if (result.ok) {
				console.log('Loaded alarm data successfully.');
				invalid = false;
				result.json().then(data => {
					console.log(`Loaded ${data.length} alarm${data.length === 1 ? '' : 's'}.`);
					stocks = data.map(stock => {
						stock.delta = stock.last - stock.limit_price;
						stock.delta_percent = stock.last / stock.limit_price - 1;
						return stock;
					});
				});
			} else {
				invalid = true;
				console.warn('Could not load alarm data.', result.statusText);
			}
		});
	}

	async function deleteAlarm() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/delete_alarm.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify({ id: stock.alarm_id, isin: stock.isin })
		}).then(result => {
			if (result.ok) {
				result.json().then(data => {
					console.log('Deleted asset from alarm:', data);
					dispatch('message', {
						type: 'success',
						text: data.message
					});
				});
			} else {
				console.warn('Could not delete asset from alarm.', result.statusText);
				result.json().then(data => {
					console.log('Error:', data);
					dispatch('message', {
						type: 'error',
						text: data.error != null ? data.error : data.warning
					});
				});
			}
			jQuery('#deleteAlarmDialog').modal('hide');
			loadAlarms();
		});
	}

	onMount(() => {
		jQuery('#deleteAlarmDialog').on('show.bs.modal', function (event) {
			let target =  event.relatedTarget;
			if (target != null && target.dataset != null && target.dataset['aid'] != null) {
				let aid = target.dataset['aid'];
				stock = stocks.find(item => item.alarm_id == aid);
				console.log('Delete alarm with ID ' + aid, stock);
			}
		});
		loadAlarms();
	});
</script>

<div class="container-fluid">
	<div class="row">
		<div class="col">
			<h2 class="mt-4 mb-2"><a class="text-light" href="#collapseAlarms" data-toggle="collapse" aria-expanded="true">Alarms</a></h2>

			<SortableTable id="collapseAlarms" class="table table-sm table-dark table-striped" containerClass="collapse show" headClass="bg-secondary" items={stocks}>
				<tr slot="thead">
					<th data-sort="name" data-sort-initial="ascending">Name</th>
					<th class="hide-md" data-sort="symbol">Symbol</th>
					<th class="hide-lg" data-sort="isin">ISIN</th>
					<th data-sort="currency">Currency</th>
					<th class="text-right" data-sort="last">Last</th>
					<th class="text-right" data-sort="limit_price">Limit</th>
					<th class="hide-lg" data-sort="reached_at">Reached at</th>
					<th class="text-right" data-sort="delta">Diff</th>
					<th class="text-right" data-sort="delta_percent">Diff %</th>
					<th></th>
				</tr>
				<tr slot="tbody" let:item={stock}>
					<StockTableCell {stock} show='name' href="." target="#assetDetailsDialog"/>
					<StockTableCell {stock} show='symbol' class="hide-md" href="." target="#assetDetailsDialog"/>
					<StockTableCell {stock} show='isin' class="hide-lg" href="." target="#assetDetailsDialog"/>
					<StockTableCell {stock} show='currency'/>
					<StockTableCell {stock} show='last'/>
					<StockTableCell {stock} show='limit_price'/>
					<StockTableCell {stock} show='reached_at' class="hide-lg"/>
					<StockTableCell {stock} show='delta'/>
					<StockTableCell {stock} show='delta_percent'/>
					<td class="col-action">
						<div class="btn-group" role="group">
							<button type="button" class="btn btn-link text-light fas fa-ellipsis-v" data-toggle="dropdown"></button>
							<div class="dropdown-menu dropdown-menu-right">
								<a href="." class="dropdown-item" data-toggle="modal" data-target="#deleteAlarmDialog" data-aid={stock.alarm_id}>Delete</a>
							</div>
						</div>
					</td>
				</tr>
			</SortableTable>
		</div>
	</div>
</div>

<div class="modal fade" id="deleteAlarmDialog" tabindex="-1" role="alert">
	<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header bg-warning">
				<h5 class="modal-title text-dark">Caution</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body text-dark">
				{#if stock != null}
				Do you really want to remove the {stock.type} limit of {formatCurrency(stock.limit_price / stock.factor)} for {stock.name} ({stock.isin}) from the alarms?
				{/if}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-danger" data-dismiss="modal">No, keep it!</button>
				<button type="button" class="btn btn-success" on:click|preventDefault={deleteAlarm}>Yes, delete it.</button>
			</div>
		</div>
	</div>
</div>
